// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_35wyOQfdwR","base":"_1Mg1Q9ZsXW"};